import { useContext } from "react";
import SocketIOContext from "./contexts/Kiosk/SocketProvider/SocketIOContext";

// const flexParentPanel = {
//   //backgroundColor: "lightgrey",
//   marginTop: "10vh",
//   marginBottom: "10vh",
//   height: "80vh",
//   marginLeft: "clamp(20px,5vw, 95px)",
//   marginRight: "clamp(20px,5vw, 95px)"
// };

// /* flexbox centered colmuns */

// const flexLeftPanel = {
//   backgroundColor: "rgb(39, 167, 55)",
//   //backgroundImage: "url(/img/BottlePattern.svg)",  //as per https://gitlab.com/tgayef/lt3-kiosk/-/issues/28
//   backgroundSize: "310px 310px",
//   backgroundRepeat: "repeat",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center",
//   height: "100vh",
//   paddingLeft: "0px",
//   paddingTop: "0px" //Fix for Grid leaving space at the bottom
//   //maxWidth: "800px",
//   //marginLeft: "auto"
// };

// const flexLeftPanelMobile = {
//   backgroundColor: "rgb(39, 167, 55)",
//   //backgroundImage: "url(/img/BottlePattern.svg)",
//   backgroundSize: "310px 310px",
//   backgroundRepeat: "repeat",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center",
//   height: "100vh",
//   paddingLeft: "0px",
//   width: "100vw"
// };

// const flexRightPanel = {
//   backgroundColor: "white",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center",
//   height: "100vh",
//   paddingLeft: "0px",
//   paddingTop: "0px" //Fix for Grid leaving space at the bottom
//   //maxWidth: "800px",
//   //marginRight: "auto"
// };

// const flexRightPanelMobile = {
//   backgroundColor: "white",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center",
//   height: "100vh",
//   paddingLeft: "0px",
//   width: "100vw"
// };

// const flexLeftPanelContents = {
//   width: "100%",
//   maxWidth: "800px",
//   marginLeft: "auto"
//   //backgroundColor: "green"
// };

// const flexRightPanelContents = {
//   width: "100%",
//   maxWidth: "800px",
//   marginRight: "auto",
//   overflow: "hidden"
// };

// /* layouts for centered colmuns */

// /* layout A: One element Center */
// const flexPanelLayoutA_CenterContainer = {
//   height: "100%",
//   //backgroundColor: "blue",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center"
// };

// /* layout B: 3 element layout */
// const flexPanelLayoutB_TopContainer = {
//   // height: "15%",
//   // //backgroundColor: "blue",
//   // display: "flex",
//   // flexDirection: "column-reverse",
//   // alignItems: "center",
//   // //justifyContent: "center",
//   // alignContent: "flex-end",
//   // alignSelf: "flex-start"

//   height: "15%",
//   //backgroundColor: "blue",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   //justifyContent: "center",
//   //alignContent: "flex-end",
//   alignSelf: "flex-start"
// };

// const flexPanelLayoutB_MidContainer = {
//   height: "70%",
//   //backgroundColor: "grey",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center"
// };

// const flexPanelLayoutB_BotContainer = {
//   height: "15%",
//   //backgroundColor: "blue",
//   display: "flex",
//   flexDirection: "column-reverse",
//   alignItems: "center"
// };

// /* layout C: 2 element layout */
// const flexPanelLayoutC_TopContainer = {
//   // height: "15%",
//   // //backgroundColor: "blue",
//   // display: "flex",
//   // flexDirection: "column-reverse",
//   // alignItems: "center",
//   // //justifyContent: "center"
//   // alignContent: "flex-end",
//   // alignSelf: "flex-start"

//   height: "15%",
//   //backgroundColor: "blue",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   //justifyContent: "center"
//   alignContent: "flex-end",
//   alignSelf: "flex-start"
// };

// // const flexPanelLayoutC_MidContainer = {
// //   height: "85%",
// //   //backgroundColor: "blue",
// //   display: "flex",
// //   flexDirection: "column",
// //   alignItems: "center"
// //   // justifyContent: "center"
// // };

// const flexPanelLayoutC_MidContainer = {
//   height: "85%",
//   //backgroundColor: "blue",
//   display: "flex",
//   flexDirection: "column-reverse",
//   alignItems: "center",
//   justifyContent: "space-between"
//   // justifyContent: "center"
// };

// //Full frame spread
// const flexPanelLayoutD = {
//   height: "100%",
//   display: "flex",
//   flexDirection: "row",
//   alignContent: "space-between",
//   flexWrap: "wrap"
// };

// const blackCornedDiv = {
//   borderRadius: "25px",
//   backgroundColor: "black",
//   color: "white",
//   maxWidth: "490px",
//   width: "41vw",
//   //height: "100%",
//   padding: "2vh 0",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center"
// };

// const blackCornedDivMarginForSubtitle = {
//   //marginTop: "12%"
// };

// const blackCornedDivReturningContainer = {
//   borderRadius: "12px",
//   backgroundColor: "black",
//   color: "white",
//   maxWidth: "280px",
//   width: "22vw",
//   height: "100%",
//   padding: "17px 30px 40px 30px",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center"
// };

// const leftRightMargins = {
//   // marginLeft: "6vw",
//   // marginRight: "6vw"
// };

// const versioning = {
//   position: "fixed",
//   // left: "3vw",
//   // bottom: "3vh",
//   left: "1vw",
//   bottom: "1vh",
//   color: "rgba(255,255,255, 0.8)"
// };

// const textButtons = {
//   margin: "25px 12px 25px 12px",
//   // paddingLeft: "2vw",
//   // paddingRight: "2vw",
//   padding: "1vw 3.5vw",
//   height: "6vh",
//   //minHeight: "23px",
//   textTransform: "capitalize",
//   //fontSize: "1.6vw"
//   fontSize: "clamp(12px, 1.3vw, 28px)",
//   borderRadius: "10px"
// };

// const blackBodyText = {
//   color: "black",
//   // fontSize: "clamp(12px, 1.6vw, 28px)"
//   fontSize: "clamp(12px, 2vw, 28px)"
//   //fontSize: "clamp(12px, 4vh, 28px)",
// };

// const whiteBodyText = {
//   color: "white",
//   fontSize: "clamp(15px, 2vw, 30px)",
//   //fontSize: "clamp(15px, 4vh, 30px)",
//   fontWeight: "400"
// };

// const whiteSubtitleText = {
//   color: "white",
//   //fontSize: "clamp(22px, 3vw, 46px)",
//   fontSize: "clamp(22px, 3vw, 35px)",
//   fontWeight: "400",
//   marginBottom: "clamp(0px, 2vw, 27px)"
// };

// const TitleToLogoAlignment = {
//   marginBottom: "clamp(6px, 0.8vw, 62px)"
// };

// //Depricated
// const EnvironmentDisplayTextStyle = {
//   color: "yellow",
//   fontSize: "clamp(12px, 3vw, 36px)",
//   fontWeight: "bold",
//   top: "0px",
//   left: "0px"
// };

// const EnvironmentDisplay = {
//   position: "relative",
//   height: "0px",
//   color: "yellow",
//   fontSize: "clamp(12px, 3vw, 36px)",
//   top: "calc(clamp(-36px,-3vw,-12px) - 1vh)",
//   //top: "clamp(-43px,-3.2vw,-19px)", //fontSize -7, -0.2vw, -7
//   fontWeight: "bold"
// };

// const EnvironmentDisplayEmptyPlaceholderStyle = {
//   marginTop: "clamp(12px, 4.5vw, 47px)"
// };

// // Text seems to start offscreen, extra margin on the left is to offset this
// const textAlignFix = {
//   // marginTop: "2vw",
//   // marginLeft: "6vw",
//   // marginRight: "2vw"
//   marginTop: "clamp(3px, 2vw, 28px)",
//   marginLeft: "clamp(3px, 6vw, 1px)",
//   marginRight: "clamp(3px, 2vw, 28px)"
// };

// //IN PROGRESS (not used hopefully)
// const PleaseSignInElement = {
//   //height: "0px",
//   color: "white",
//   // fontSize: "clamp(21px, 3vw, 48px)",
//   fontSize: "clamp(22px, 3vw, 35px)",
//   fontWeight: "400",
//   //marginTop: "1vh",
//   textAlign: "left",
//   width: "100%",
//   //paddingLeft: "clamp(150px, 3vw, 90px)"
//   //marginLeft: "clamp(10px, 15vw, 230px)",
//   marginBottom: "1vh"
// };

// const RightPanelTitle = {
//   // marginLeft: "clamp(0px, 2vw, 47px)",
//   // marginRight: "clamp(0px, 2vw, 47px)",
//   fontSize: "clamp(12px, 2.8vw, 43px)",
//   textAlign: "center"
// };

// const RightPanelTitleMobile = {
//   fontSize: "clamp(12px, 5.6vh, 43px)",
//   textAlign: "center"
// };

// const LogoTextAlignmentMatcher = {
//   //backgroundColor: "green",   //This should match with the Text from the logo
//   height: "clamp(0px,3.2vi,48px)",
//   width: "100%",
//   display: "flex",
//   flexDirection: "column",
//   alignContent: "flex-end",
//   alignSelf: "flex-start"
// };

// const LogoTextAlignmentMatcherMobile = {
//   ...LogoTextAlignmentMatcher,
//   flexDirection: "column"
// };

// //This includes the textAlignFix above
// const kioskDetails = {
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "flex-start",
//   height: "100%",
//   width: "100%",
//   marginTop: "clamp(0px, 2vh, 27px)"
//   // marginLeft: "clamp(3px, 6vw, 80px)",
//   // marginRight: "clamp(0px, 2vw, 27px)"
// };

// const kioskDetailsSpaceBetween = {
//   marginTop: "clamp(20px, 2vh, 80px)"
// };

// const biRowNumberSelect = {
//   //marginBottom: "2vw",
//   display: "flex",
//   justifyContent: "center",
//   gap: "2vw"
// };

// const HelperTextTopMargin = {
//   //marginTop: "3em"
// };

// const HelperTextColor = {
//   color: "#696969"
// };

// const StepperButtonBack = {
//   borderRadius: "1vi",
//   textTransform: "capitalize",
//   marginRight: "9px",
//   padding: "0.5vw 2vw 0.5vw 1.5vw"
// };

// const StepperButtonEnd = {
//   borderRadius: "1vi",
//   textTransform: "capitalize",
//   padding: "0.5vw 2vw 0.5vw 1.5vw"
// };

// const GridFullHeightFix = {
//   marginTop: "0px"
// };

//////////////////////////////////////////////////////////////////////////////////////////

const flexParentPanelfunc = theme => {
  return {
    //backgroundColor: "lightgrey", //DEBUG
    marginTop: "10vh",
    marginBottom: "10vh",
    height: "80vh",
    marginLeft: "clamp(20px,5vw, 95px)",
    marginRight: "clamp(20px,5vw, 95px)"
  };
};

/* flexbox centered colmuns */

const flexLeftPanelfunc = theme => {
  return {
    backgroundColor: theme.mainscreenBGColor || "rgb(39, 167, 55)",
    //backgroundImage: "url(/img/BottlePattern.svg)",  //as per https://gitlab.com/tgayef/lt3-kiosk/-/issues/28
    backgroundSize: "310px 310px",
    backgroundRepeat: "repeat",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    paddingLeft: "0px",
    paddingTop: "0px !important", //Fix for Grid leaving space at the bottom. !important is for printlabels
    //maxWidth: "800px",
    //marginLeft: "auto"
    zIndex: 20
  };
};

const flexLeftPanelMobilefunc = theme => {
  return {
    backgroundColor: theme.mainscreenBGColor || "rgb(39, 167, 55)",
    //backgroundImage: "url(/img/BottlePattern.svg)",
    backgroundSize: "310px 310px",
    backgroundRepeat: "repeat",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    paddingLeft: "0px",
    width: "100vw",
    zIndex: 20
  };
};

const flexRightPopOutPanelfunc = theme => {
  return {
    backgroundColor: theme.innerBGColor || "white",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    paddingLeft: "0px",
    paddingTop: "0px", //Fix for Grid leaving space at the bottom
    //backgroundColor: "red",
    position: "absolute",
    width: "50vw",
    left: "50vw",
    zIndex: 10
    //maxWidth: "800px",
    //marginRight: "auto"
  };
};

const flexRightPanelfunc = theme => {
  return {
    backgroundColor: theme.innerBGColor || "white",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    paddingLeft: "0px",
    paddingTop: "0px", //Fix for Grid leaving space at the bottom
    zIndex: 0
    //maxWidth: "800px",
    //marginRight: "auto"
  };
};

const flexRightPanelMobilefunc = theme => {
  return {
    backgroundColor: theme.innerBGColor || "white",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    paddingLeft: "0px",
    width: "100vw",
    zIndex: 0
  };
};

const flexLeftPanelContentsfunc = theme => {
  return {
    width: "100%",
    maxWidth: "800px",
    marginLeft: "auto"
    //backgroundColor: "green"
  };
};

const flexRightPopOutPanelContentsfunc = theme => {
  return {
    width: "100%",
    maxWidth: "800px",
    marginRight: "auto"
    //backgroundColor: "green"
  };
};

const flexRightPanelContentsfunc = theme => {
  return {
    width: "100%",
    maxWidth: "800px",
    marginRight: "auto",
    overflow: "hidden",
    color: theme.innerTextColor || "black"
  };
};

/* layouts for centered colmuns */

/* layout A: One element Center */
const flexPanelLayoutA_CenterContainerfunc = theme => {
  return {
    height: "100%",
    backgroundColor: "blue",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  };
};

const flexPanelLayoutA_FillContainerfunc = theme => {
  return {
    height: "100%",
    //backgroundColor: "blue",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between"
  };
};

/* layout B: 3 element layout */
const flexPanelLayoutB_TopContainerfunc = theme => {
  return {
    // height: "15%",
    // //backgroundColor: "blue",
    // display: "flex",
    // flexDirection: "column-reverse",
    // alignItems: "center",
    // //justifyContent: "center",
    // alignContent: "flex-end",
    // alignSelf: "flex-start"

    height: "15%",
    //backgroundColor: "blue",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    //justifyContent: "center",
    //alignContent: "flex-end",
    alignSelf: "flex-start"
  };
};

const flexPanelLayoutB_MidContainerfunc = theme => {
  return {
    height: "70%", //not sure why was removed
    //backgroundColor: "grey",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly"
  };
};

const flexPanelLayoutB_BotContainerfunc = theme => {
  return {
    height: "15%",
    //backgroundColor: "blue",
    display: "flex",
    flexDirection: "column-reverse",
    alignItems: "center"
  };
};

/* layout C: 2 element layout */
const flexPanelLayoutC_TopContainerfunc = theme => {
  return {
    // height: "15%",
    // //backgroundColor: "blue",
    // display: "flex",
    // flexDirection: "column-reverse",
    // alignItems: "center",
    // //justifyContent: "center"
    // alignContent: "flex-end",
    // alignSelf: "flex-start"

    height: "15%",
    //backgroundColor: "blue",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    //justifyContent: "center"
    alignContent: "flex-end",
    alignSelf: "flex-start"
  };
};

// const flexPanelLayoutC_MidContainer = {
//   height: "85%",
//   //backgroundColor: "blue",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center"
//   // justifyContent: "center"
// };

const flexPanelLayoutC_MidContainerfunc = theme => {
  return {
    height: "85%",
    //backgroundColor: "blue",
    display: "flex",
    //flexDirection: "column-reverse",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around"
    // justifyContent: "center"
  };
};

//Full frame spread
const flexPanelLayoutDfunc = theme => {
  return {
    height: "100%",
    display: "flex",
    flexDirection: "row",
    alignContent: "space-between",
    flexWrap: "wrap"
    //color: "white"
  };
};

const blackCornedDivfunc = theme => {
  return {
    borderRadius: "2vh",
    backgroundColor: theme.quickStartQRDivColor || "black",
    color: theme.quickStartQRTextColor || "white",
    //maxWidth: "490px",
    width: "41vw",
    //height: "100%",
    padding: "2vh 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "100%"
  };
};

const blackCornedDivMarginForSubtitlefunc = theme => {
  return {
    //marginTop: "12%"
  };
};

const blackCornedDivReturningContainerfunc = theme => {
  return {
    borderRadius: "2vh",
    backgroundColor: theme.telephoneConfirmDivColor || "black",
    color: theme.telephoneConfirmTextColor || "white",
    maxWidth: "280px",
    width: "22vw",
    height: "100%",
    //padding: "17px 30px 40px 30px",
    //padding: "5vh 10vh 20vh 10vh",
    padding: "2.4vh 4.2vh 5.4vh 4.2vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  };
};

const quickDonationDivfunc = theme => {
  return {
    borderRadius: "2vh",
    backgroundColor: theme.quickStartQuickDonateDivColor || "black",
    color: theme.quickStartQuickDonateTextColor || "white",
    //maxWidth: "490px",
    width: "41vw",
    //height: "100%",
    padding: "2vh 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "100%"
  };
};

const leftRightMarginsfunc = theme => {
  return {
    // marginLeft: "6vw",
    // marginRight: "6vw"
  };
};

const versioningfunc = theme => {
  return {
    position: "fixed",
    // left: "3vw",
    // bottom: "3vh",
    left: "1vw",
    bottom: "1vh",
    color: "rgba(255,255,255, 0.8)"
  };
};

const textButtonsfunc = theme => {
  return {
    margin: "25px 12px 25px 12px",
    // paddingLeft: "2vw",
    // paddingRight: "2vw",
    //padding: "1vw 3.5vw",
    padding: "1vh 6.2vh",
    height: "6vh",
    //minHeight: "23px",
    textTransform: "capitalize",
    //fontSize: "1.6vw"
    fontSize: "clamp(6px, 2.3vh, 28px)",
    borderRadius: "1.2vh"
  };
};

const blackBodyTextfunc = theme => {
  return {
    color: theme.innerTextColor || "black",
    // fontSize: "clamp(12px, 1.6vw, 28px)"
    //fontSize: "clamp(12px, 2vw, 28px)"

    fontSize: "clamp(12px, 3.2vh, 28px)"
  };
};

const whiteBodyTextfunc = theme => {
  return {
    color: theme.mainscreenTextColor || "white",
    //fontSize: "clamp(7.5px, 2vw, 30px)",
    fontSize: "clamp(7.5px, 3.5vh, 30px)",
    fontWeight: "400"
  };
};

const whiteSubtitleTextfunc = theme => {
  return {
    color: theme.mainscreenTextColor || "white",
    //fontSize: "clamp(22px, 3vw, 46px)",
    fontSize: "clamp(5.5px, 5vh, 35px)",
    fontWeight: "400",
    marginBottom: "clamp(0px, 3.5vh, 27px)"
  };
};

const errorScreenfunc = theme => {
  return {
    subtitleText: {
      color: "black", //theme.mainscreenTextColor ||
      //fontSize: "clamp(22px, 3vw, 46px)",
      fontSize: "clamp(5.5px, 5vh, 35px)",
      fontWeight: "400",
      marginBottom: "clamp(0px, 3.5vh, 27px)"
    }
  };
};

const TitleToLogoAlignmentfunc = theme => {
  return { marginBottom: "clamp(6px, 0.8vw, 62px)" };
};

//Depricated
const EnvironmentDisplayTextStylefunc = theme => {
  return {
    color: "yellow",
    fontSize: "clamp(12px, 3vw, 36px)",
    fontWeight: "bold",
    top: "0px",
    left: "0px"
  };
};

const EnvironmentDisplayfunc = theme => {
  return {
    position: "relative",
    height: "0px",
    color: "yellow",
    fontSize: "clamp(12px, 5vh, 36px)",
    top: "calc(clamp(-36px,-5vh,-12px) - 1vh)",
    //top: "clamp(-43px,-3.2vw,-19px)", //fontSize -7, -0.2vw, -7
    fontWeight: "bold"
  };
};

const EnvironmentDisplayEmptyPlaceholderStylefunc = theme => {
  return { marginTop: "clamp(12px, 4.5vw, 47px)" };
};

// Text seems to start offscreen, extra margin on the left is to offset this
const textAlignFixfunc = theme => {
  return {
    // marginTop: "2vw",
    // marginLeft: "6vw",
    // marginRight: "2vw"
    marginTop: "clamp(3px, 2vw, 28px)",
    marginLeft: "clamp(3px, 6vw, 1px)",
    marginRight: "clamp(3px, 2vw, 28px)"
  };
};

const PleaseSignInElementfunc = theme => {
  return {
    //height: "0px",
    color: theme.mainscreenTextColor || "white",
    //color: "white",
    // fontSize: "clamp(21px, 3vw, 48px)",
    //fontSize: "clamp(11px, 3vw, 35px)",
    //fontSize: "clamp(11px, 6vh, 35px)",
    fontSize: "clamp(11px, 3.4vh, 35px)",
    textSizeAdjust: "auto",
    fontWeight: "400",
    //marginTop: "1vh",
    textAlign: "left",
    //textAlign: "center",
    width: "100%",
    maxWidth: "608px",
    //paddingLeft: "clamp(150px, 3vw, 90px)"
    //marginLeft: "clamp(10px, 15vw, 230px)",
    marginBottom: "1vh"
  };
};

const RightPanelTitlefunc = theme => {
  return {
    // marginLeft: "clamp(0px, 2vw, 47px)",
    // marginRight: "clamp(0px, 2vw, 47px)",
    fontSize: "clamp(12px, 2.8vw, 43px)",
    textAlign: "center"
  };
};

const RightPanelTitleMobilefunc = theme => {
  return { fontSize: "clamp(12px, 5.6vh, 43px)", textAlign: "center" };
};

const LogoTextAlignmentMatcherfunc = theme => {
  return {
    //backgroundColor: "green",   //This should match with the Text from the logo
    height: "clamp(0px,3.2vi,48px)",
    //height: "clamp(0px,5.6vh,48px)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-end",
    alignSelf: "flex-start"
  };
};

const LogoTextAlignmentMatcherMobilefunc = theme => {
  return { ...LogoTextAlignmentMatcherfunc(theme), flexDirection: "column" };
};

//This includes the textAlignFix above
const kioskDetailsfunc = theme => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    height: "100%",
    width: "100%",
    marginTop: "clamp(0px, 2vh, 27px)"
    // marginLeft: "clamp(3px, 6vw, 80px)",
    // marginRight: "clamp(0px, 2vw, 27px)"
  };
};

const kioskDetailsSpaceBetweenfunc = theme => {
  return { marginTop: "clamp(6px, 2vh, 80px)" };
};

const biRowNumberSelectfunc = theme => {
  return {
    //marginBottom: "2vw",
    display: "flex",
    justifyContent: "center",
    gap: "2vw"
  };
};

const HelperTextTopMarginfunc = theme => {
  return {
    //marginTop: "3em"
  };
};

const HelperTextColorfunc = theme => {
  return { color: "#696969" };
};

const StepperButtonBackfunc = theme => {
  return {
    borderRadius: "1vi",
    textTransform: "capitalize",
    marginRight: "9px",
    //padding: "0.5vw 2vw 0.5vw 1.5vw",
    padding: "0.5vh 3vh 0.5vh 1.5vh",
    height: "4vh",
    fontSize: "2vh",
    backgroundColor: theme.stepperButtonBGColor,
    color: theme.stepperButtonTextColor,
    //paddingInline: "",
    paddingBlock: "0.55vh"
  };
};

const StepperButtonEndfunc = theme => {
  return {
    borderRadius: "1vi",
    textTransform: "capitalize",
    //padding: "0.5vw 2vw 0.5vw 1.5vw",
    padding: "0.5vh 3vh 0.5vh 1.5vh",
    height: "4vh",
    fontSize: "2vh",
    backgroundColor: theme.stepperButtonBGColor,
    color: theme.stepperButtonTextColor,
    paddingBlock: "0.55vh"
  };
};

const GridFullHeightFixfunc = theme => {
  return { marginTop: "0px" };
};

const languageselectfunc = theme => {
  return {
    title: {
      fontSize: "clamp(1.5rem, 9.5vh, 4.3rem)",
      textAlign: "center",
      color: theme.mainscreenTextColor || "white"
      //marginTop: "-6vh" //fix for text not reaching to top of div
    },
    button: {
      backgroundColor: theme.mainscreenButtonsBGColor || "white",
      color: theme.mainscreenButtonsTextColor || "rgb(39, 167, 55)",
      fontSize: "clamp(0.7rem, 4vh, 2.5rem)",
      fontStyle: "italic",
      border: "0px solid white"
    }
  };
};

const phonenumberfunc = theme => {
  return {
    qrdiv: {
      display: "flex",
      flexDirection: "column",
      width: "65%",
      marginLeft: "2vh",
      marginRight: "2vh",
      justifyContent: "center"
      // marginBottom: "4.6vh",
      // height: "24vh",
      // width: "83vw",
      // display: "flex",
      // flexDirection: "row",
      // alignItems: "center",
      // justifyContent: "space-between",
      // marginLeft: "8.5vw",
      // marginRight: "8.5vw",
      // borderRadius: "1.8vh",
      // backgroundColor: theme.quickStartQRDivColor || "black",
      // color: theme.quickStartQRTextColor || "white"
    },
    quickdonationdiv: {
      display: "flex",
      flexDirection: "column",
      width: "65%",
      marginLeft: "2vh",
      marginRight: "2vh",
      justifyContent: "space-around"
    },
    qrelement: {
      //background: "white",
      // padding: ".5vh",\
      padding: "1vh",
      marginLeft: "2vh",
      //width: "35%",
      // width: "22vh",
      // height: "22vh"
      width: "18vh",
      height: "18vh",
      // marginLeft: "3vh",
      // height: "18vh",
      // width: "18vh",
      // borderRadius: "0.4vh",
      backgroundColor: theme.quickStartQRBGColor || "white",
      borderRadius: "0.8vh"
      // display: "flex",
      // padding: "1vw"
    },
    qrtitleelement: {
      textAlign: "center",
      fontSize: "clamp(10px, 2.8vh, 34px)"
    },
    qrbodyelement: {
      textAlign: "center",
      fontSize: "clamp(5.5px, 1.7vh, 24px)"
    },
    donationButtonIcon: {
      background: "white",
      // padding: ".5vh",
      padding: "1vh",
      marginLeft: "2vh",
      //width: "35%",
      width: "18vh", //Match with qrelement
      //height: "60%",
      backgroundColor: theme.quickStartQuickDonateBGColor || "white",
      color: theme.quickStartQuickDonateIconColor || "black",
      borderRadius: "0.8vh",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center"
    },

    // qrtextelement: {
    //   // width: "45vw",
    //   // height: "100%",
    //   // marginRight: "3vw",
    //   // marginLeft: "2vw",
    //   // display: "flex",
    //   // flexDirection: "column",
    //   // alignItems: "center",
    //   // justifyContent: "center"
    // },
    enterSlowlyText: {
      width: "100%",
      textAlign: "center",
      fontSize: "clamp(6px, 1.4vw, 21.5px)"
    },
    quickStartQRCodeColor: theme.quickStartQRCodeColor,
    quickStartQRBGColor: theme.quickStartQRBGColor,
    quickStartQRTextColor: theme.quickStartQRTextColor
  };
};

const charitiesfunc = theme => {
  return {
    selectInstruction: {
      width: "100%",
      textAlign: "center",
      fontSize: "clamp(6px, 3.4vh, 33px)",
      marginBottom: "0.5vh"
    },
    charityElement: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      //backgroundColor: "red",
      backgroundColor: theme.charityElementBgColor || "black",
      //width: "20vh",
      //height: "20vh",
      flex: "1",
      //minWidth: 'calc(50% - 5px)',
      //minWidth: "14vh",
      minWidth: "10vh",
      aspectRatio: "1",
      margin: "0.2vh",
      borderRadius: "1.5vh" /* Rounded corners */,
      boxShadow:
        "0 0.5vh 0.75vh -0.125vh rgba(0, 0, 0, 0.1), 0 0.25vh 0.5vh -0.125vh rgba(0, 0, 0, 0.06)" /* Soft shadow */,
      padding: "1.5vh"
    },
    charityElementTitle: {
      fontSize: "1.4cqh",
      textAlign: "center"
    },
    charityElementDescription: {
      fontSize: "1.2cqh",
      textAlign: "center"
      // height: "3vh",
      // overflow: "clip"
    },
    charityElementLogo: {
      width: "100%",
      aspectRatio: "2/1",
      objectFit: "scale-down"
    },
    charityElementDefaultLogoIcon: {
      color: theme.charityElementButtonColor || "rgb(39, 167, 55)",
      width: "100%",
      height: "50%",
      aspectRatio: "2/1",
      "& svg": {
        width: "100%",
        height: "50%"
      }
    },
    charityElementButton: {
      fontSize: "1.2cqh",
      padding: "0.3cqh 0.6cqh",
      color: theme.charityElementButtonColor || "black",
      borderColor: theme.charityElementButtonColor || "black", // Border color (for outlined variant)
      backgroundColor: theme.charityElementButtonBGColor || "",
      // "&:hover": {
      //   backgroundColor: "#your-hover-bg-color",
      //   borderColor: "#your-hover-border-color"
      // }
      minWidth: "0",
      textTransform: "none"
    },
    charitySearchButton: {
      backgroundColor: theme.charityFindButtonColor || "black",
      textTransform: "none" // This makes it regular casing (removes uppercase)
    },
    charityModalTextColor: {
      color: theme.charityModalTextColor || "black"
    }

    // ConfirmSelect: {
    //   instruction: {

    //   }
    // }
  };
};

const mainfontsizefunc = theme => {
  return {
    fontSize: "3.2vh"
  };
};

const modalsfunc = theme => {
  return {
    printererrormodal: {
      title: {
        color: "black",
        textAlign: "center",
        fontWeight: "bold",
        marginBottom: "2vh"
      },
      iconcontainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
      },
      icon: { fontSize: "10vh", marginBottom: "2vh" },
      body: {
        width: "33vw",
        fontSize: "clamp(5.5px, 3vh, 24px)",
        textAlign: "center",
        marginBottom: "2vh"
      },
      buttonstyle: {
        margin: "3vh 0vh 1vh 0vh",
        padding: "1vh 6.2vh",
        height: "6vh",
        textTransform: "capitalize",
        fontSize: "clamp(6px, 2.3vh, 28px)",
        borderRadius: "1.2vh"
      }
    }
  };
};

// export const kioskstyles = {
//   flexParentPanel: flexParentPanel,
//   flexLeftPanel: flexLeftPanel,
//   flexLeftPanelMobile: flexLeftPanelMobile,
//   flexRightPanel: flexRightPanel,
//   flexRightPanelMobile: flexRightPanelMobile,
//   flexLeftPanelContents: flexLeftPanelContents,
//   flexRightPanelContents: flexRightPanelContents,
//   flexPanelLayoutA_CenterContainer: flexPanelLayoutA_CenterContainer,
//   flexPanelLayoutB_TopContainer: flexPanelLayoutB_TopContainer,
//   flexPanelLayoutB_MidContainer: flexPanelLayoutB_MidContainer,
//   flexPanelLayoutB_BotContainer: flexPanelLayoutB_BotContainer,
//   flexPanelLayoutC_TopContainer: flexPanelLayoutC_TopContainer,
//   flexPanelLayoutC_MidContainer: flexPanelLayoutC_MidContainer,
//   flexPanelLayoutD: flexPanelLayoutD,
//   TitleToLogoAlignment: TitleToLogoAlignment,
//   EnvironmentDisplayTextStyle: EnvironmentDisplayTextStyle,
//   EnvironmentDisplay: EnvironmentDisplay,
//   EnvironmentDisplayEmptyPlaceholderStyle: EnvironmentDisplayEmptyPlaceholderStyle,
//   textAlignFix: textAlignFix,
//   PleaseSignInElement: PleaseSignInElement,
//   kioskDetails: kioskDetails,
//   leftRightMargins: leftRightMargins,
//   RightPanelTitle: RightPanelTitle,
//   RightPanelTitleMobile: RightPanelTitleMobile,
//   LogoTextAlignmentMatcher: LogoTextAlignmentMatcher,
//   LogoTextAlignmentMatcherMobile: LogoTextAlignmentMatcherMobile,
//   versioning: versioning,
//   textButtons: textButtons,
//   blackBodyText: blackBodyText,
//   whiteBodyText: whiteBodyText,
//   whiteSubtitleText: whiteSubtitleText,
//   kioskDetailsSpaceBetween: kioskDetailsSpaceBetween,
//   biRowNumberSelect: biRowNumberSelect,
//   HelperTextTopMargin: HelperTextTopMargin,
//   HelperTextColor: HelperTextColor,
//   StepperButtonBack: StepperButtonBack,
//   StepperButtonEnd: StepperButtonEnd,
//   GridFullHeightFix: GridFullHeightFix,

//   blackCornedDiv: blackCornedDiv,
//   blackCornedDivMarginForSubtitle: blackCornedDivMarginForSubtitle,
//   blackCornedDivReturningContainer: blackCornedDivReturningContainer
// };

export const useKioskHorizontalStyles = () => {
  const { getKioskTheme } = useContext(SocketIOContext);
  const theme = getKioskTheme();

  return {
    flexParentPanel: flexParentPanelfunc(theme),
    flexLeftPanel: flexLeftPanelfunc(theme),
    flexLeftPanelMobile: flexLeftPanelMobilefunc(theme),
    flexRightPopOutPanel: flexRightPopOutPanelfunc(theme),
    flexRightPanel: flexRightPanelfunc(theme),
    flexRightPanelMobile: flexRightPanelMobilefunc(theme),
    flexLeftPanelContents: flexLeftPanelContentsfunc(theme),
    flexRightPopOutPanelContents: flexRightPopOutPanelContentsfunc(theme),
    flexRightPanelContents: flexRightPanelContentsfunc(theme),
    flexPanelLayoutA_CenterContainer: flexPanelLayoutA_CenterContainerfunc(
      theme
    ),
    flexPanelLayoutA_FillContainer: flexPanelLayoutA_FillContainerfunc(theme),
    flexPanelLayoutB_TopContainer: flexPanelLayoutB_TopContainerfunc(theme),
    flexPanelLayoutB_MidContainer: flexPanelLayoutB_MidContainerfunc(theme),
    flexPanelLayoutB_BotContainer: flexPanelLayoutB_BotContainerfunc(theme),
    flexPanelLayoutC_TopContainer: flexPanelLayoutC_TopContainerfunc(theme),
    flexPanelLayoutC_MidContainer: flexPanelLayoutC_MidContainerfunc(theme),
    flexPanelLayoutD: flexPanelLayoutDfunc(theme),
    TitleToLogoAlignment: TitleToLogoAlignmentfunc(theme),
    EnvironmentDisplayTextStyle: EnvironmentDisplayTextStylefunc(theme),
    EnvironmentDisplay: EnvironmentDisplayfunc(theme),
    EnvironmentDisplayEmptyPlaceholderStyle: EnvironmentDisplayEmptyPlaceholderStylefunc(
      theme
    ),
    textAlignFix: textAlignFixfunc(theme),
    PleaseSignInElement: PleaseSignInElementfunc(theme),
    kioskDetails: kioskDetailsfunc(theme),
    leftRightMargins: leftRightMarginsfunc(theme),
    RightPanelTitle: RightPanelTitlefunc(theme),
    RightPanelTitleMobile: RightPanelTitleMobilefunc(theme),
    LogoTextAlignmentMatcher: LogoTextAlignmentMatcherfunc(theme),
    LogoTextAlignmentMatcherMobile: LogoTextAlignmentMatcherMobilefunc(theme),
    versioning: versioningfunc(theme),
    textButtons: textButtonsfunc(theme),
    blackBodyText: blackBodyTextfunc(theme),
    whiteBodyText: whiteBodyTextfunc(theme),
    whiteSubtitleText: whiteSubtitleTextfunc(theme),
    errorScreen: errorScreenfunc(theme),
    kioskDetailsSpaceBetween: kioskDetailsSpaceBetweenfunc(theme),
    biRowNumberSelect: biRowNumberSelectfunc(theme),
    HelperTextTopMargin: HelperTextTopMarginfunc(theme),
    HelperTextColor: HelperTextColorfunc(theme),
    StepperButtonBack: StepperButtonBackfunc(theme),
    StepperButtonEnd: StepperButtonEndfunc(theme),
    GridFullHeightFix: GridFullHeightFixfunc(theme),

    blackCornedDiv: blackCornedDivfunc(theme),
    blackCornedDivMarginForSubtitle: blackCornedDivMarginForSubtitlefunc(theme),
    blackCornedDivReturningContainer: blackCornedDivReturningContainerfunc(
      theme
    ),
    quickDonationDiv: quickDonationDivfunc(theme),

    languageselect: languageselectfunc(theme),
    phonenumber: phonenumberfunc(theme),
    charities: charitiesfunc(theme),
    mainfontsize: mainfontsizefunc(theme),
    modals: modalsfunc(theme)
  };
};

// root: {
//   background: "white",

//   "@media (max-width: 1920px)": {
//     background: "red",
//   }
//  }
